/**
 * API cho hệ thống affiliate
 */

// URL gốc cho API
const API_BASE_URL = process.env.REACT_APP_API_URL || "";

/**
 * Ghi nhận click affiliate
 * @param {string} affiliateId - ID của người giới thiệu
 * @param {string} campaign - Tên chiến dịch (không bắt buộc)
 * @param {string} source - Nguồn của click (không bắt buộc)
 * @param {string} url - URL được click
 * @returns {Promise} Kết quả từ API
 */
export const trackAffiliateClick = async (
  affiliateId,
  campaign = "",
  source = "",
  url = ""
) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/affiliate/track-click`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        affiliateId,
        campaign,
        source,
        url,
      }),
    });

    return await response.json();
  } catch (error) {
    console.error("Lỗi khi ghi nhận click affiliate:", error);
    throw error;
  }
};

/**
 * Theo dõi đăng ký người dùng qua affiliate
 * @param {string} userId - ID của người dùng mới đăng ký
 * @param {string} affiliateId - ID của người giới thiệu
 * @param {string} campaign - Tên chiến dịch (không bắt buộc)
 * @param {string} source - Nguồn của đăng ký (không bắt buộc)
 * @returns {Promise} Kết quả từ API
 */
export const trackAffiliateSignup = async (
  userId,
  affiliateId,
  campaign = "",
  source = ""
) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/affiliate/track-signup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId,
        affiliateId,
        campaign,
        source,
      }),
    });

    return await response.json();
  } catch (error) {
    console.error("Lỗi khi ghi nhận đăng ký affiliate:", error);
    throw error;
  }
};

/**
 * Hoàn thành đăng ký affiliate
 * @param {string} userId - ID của người dùng đã đăng ký
 * @param {string} affiliateId - ID của người giới thiệu
 * @returns {Promise} Kết quả từ API
 */
export const completeAffiliateSignup = async (userId, affiliateId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/affiliate/complete-signup`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId,
          affiliateId,
        }),
      }
    );

    return await response.json();
  } catch (error) {
    console.error("Lỗi khi hoàn thành đăng ký affiliate:", error);
    throw error;
  }
};

/**
 * Theo dõi thanh toán qua affiliate
 * @param {string} userId - ID của người dùng thanh toán
 * @param {string} affiliateId - ID của người giới thiệu
 * @param {number} amount - Số tiền thanh toán
 * @param {string} campaign - Tên chiến dịch (không bắt buộc)
 * @param {string} source - Nguồn của thanh toán (không bắt buộc)
 * @returns {Promise} Kết quả từ API
 */
export const trackAffiliatePayment = async (
  userId,
  affiliateId,
  amount,
  campaign = "",
  source = ""
) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/affiliate/track-payment`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId,
          affiliateId,
          amount,
          campaign,
          source,
        }),
      }
    );

    return await response.json();
  } catch (error) {
    console.error("Lỗi khi ghi nhận thanh toán affiliate:", error);
    throw error;
  }
};

/**
 * Lấy thống kê affiliate
 * @param {string} userId - ID của người dùng cần lấy thống kê
 * @returns {Promise} Kết quả từ API
 */
export const getAffiliateStats = async (userId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/affiliate/stats/${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return await response.json();
  } catch (error) {
    console.error("Lỗi khi lấy thống kê affiliate:", error);
    throw error;
  }
};

/**
 * Đánh dấu thông báo đã đọc
 * @param {string} userId - ID của người dùng
 * @param {string} notificationId - ID của thông báo
 * @returns {Promise} Kết quả từ API
 */
export const markNotificationRead = async (userId, notificationId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/affiliate/mark-notification-read`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId,
          notificationId,
        }),
      }
    );

    return await response.json();
  } catch (error) {
    console.error("Lỗi khi đánh dấu thông báo đã đọc:", error);
    throw error;
  }
};
